var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34735 2.23156V0.38501H0.891113V8.69449H9.80358V2.23156H5.34735ZM2.67361 7.77122H1.78236V6.84794H2.67361V7.77122ZM2.67361 5.92467H1.78236V5.00139H2.67361V5.92467ZM2.67361 4.07811H1.78236V3.15484H2.67361V4.07811ZM2.67361 2.23156H1.78236V1.30829H2.67361V2.23156ZM4.4561 7.77122H3.56485V6.84794H4.4561V7.77122ZM4.4561 5.92467H3.56485V5.00139H4.4561V5.92467ZM4.4561 4.07811H3.56485V3.15484H4.4561V4.07811ZM4.4561 2.23156H3.56485V1.30829H4.4561V2.23156ZM8.91233 7.77122H5.34735V6.84794H6.23859V5.92467H5.34735V5.00139H6.23859V4.07811H5.34735V3.15484H8.91233V7.77122ZM8.02109 4.07811H7.12984V5.00139H8.02109V4.07811ZM8.02109 5.92467H7.12984V6.84794H8.02109V5.92467Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.addc049003b4fec1553ed82ce4252d51.svg";
export { ForwardRef as ReactComponent };